import { render, staticRenderFns } from "./ModuleTutorialSetProfile.vue?vue&type=template&id=7aa0a4e4&scoped=true&lang=pug&"
import script from "./ModuleTutorialSetProfile.vue?vue&type=script&lang=js&"
export * from "./ModuleTutorialSetProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTutorialSetProfile.vue?vue&type=style&index=0&id=7aa0a4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa0a4e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
